<div id="maintenance" class="lg-form-container" fxLayout="column" ngcPerfectScrollbar>

    <div id="maintenance-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="maintenance-form" class="lg-form">

            <div class="logo" alt="logo"></div>

            <div class="title">
                <div class="mb-16">Sorry!</div>
                {{IS_SCHEDULED_MAINTENANCE ? SCHEDULED_MAINTENANCE_TITLE : SERVICE_UNAVAILABLE_TITLE}}
            </div>

            <div class="subtitle">
                {{IS_SCHEDULED_MAINTENANCE ? SCHEDULED_MAINTENANCE_MESSAGE : SERVICE_UNAVAILABLE_MESSAGE}}
                <!--<br>-->
                <!--Thanks for your patience.-->
            </div>

        </div>

    </div>

    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>

</div>
